<template>
  <div>
    <Spinner v-if="isLoading" />
    <div v-else-if="getBoletosError" class="notification-content">
      <Message :message="getBoletosError.message" :icon="getBoletosError.icon" />
    </div>
    <div v-else class="transactions-view">
      <div class="header-container">
        <span>Status do Boleto</span>
        <b-dropdown
          id="filtro-status"
          v-model="selectedStatus"
          position="is-bottom-right"
          append-to-body
          :close-on-click="true"
          :mobile-modal="false"
          aria-role="list"
          @active-change="updateBoletosHistory($event)">
          <template #trigger>
            <b-button
              rounded
              class="status-filter-button"
              type="is-button-secondary">
              <span class="icon is-small">
                <i class="fas fa-filter" />
              </span>
              <span>Filtrar</span>
            </b-button>
          </template>
          <b-dropdown-item
            v-for="(value, status) in statusFilter"
            :id="value"
            :key="status"
            :value="value"
            aria-role="listitem">
            <span>{{ status }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div v-if="getBoletosMessage" class="notification-content">
        <Message :message="getBoletosMessage.message" :icon="getBoletosMessage.icon" :as-card="false" />
      </div>
      <div v-else class="transactions-container">
        <SingleBoleto
          v-for="boleto in boletos"
          :key="boleto._id"
          :current-user-is-client="currentUserIsClient"
          :is-extended="false"
          :boleto="boleto" />
        <creditu-pagination
          v-if="!isLoading && numberOfDocuments > boletos.length"
          :page-number.sync="pageNumber"
          size="is-small"
          :documents-per-page.sync="documentsPerPage"
          items-name="Boletos"
          :total="numberOfDocuments"
          :range-before="1"
          :range-after="1"
          :documents-per-page-options="[10, 20, 50]" />
      </div>
    </div>
  </div>
</template>
<script>
import SingleBoleto from '@/ui/components/internal/pay-here/SingleBoleto.vue';
import CredituPagination from '@/ui/components/CredituPagination.vue';
import Spinner from '@/ui/components/Spinner.vue';
import Message from '@/ui/components/Message.vue';
import { getClientBoletos } from '@/application/services/api-clients/clients';

export default {
  components: { SingleBoleto, CredituPagination, Spinner, Message },
  props: {
    paymentProviders: { type: Array, default: () => [] },
    clientId: { type: String, default: '' },
    currentUserIsClient: { type: Boolean, default: false }
  },
  data() {
    return {
      debtMessage: '',
      getBoletosError: '',
      getBoletosMessage: '',
      isLoading: false,
      selectedStatus: [],
      statusDictionary: {
        REQUESTED: 'REQUERIDO',
        PAID: 'PAGO',
        EXPIRED: 'EXPIRADO',
        CANCELLED: 'CANCELADO'
      },
      statusFilter: {
        REQUERIDO: 'REQUESTED',
        PAGO: 'PAID',
        EXPIRADO: 'EXPIRED',
        CANCELADO: 'CANCELLED',
        TODOS: 'undefined'
      },
      boletos: [],
      documentsPerPage: 10,
      numberOfDocuments: 0,
      pageNumber: 1
    };
  },
  watch: {
    boletos: {
      depp: true,
      handler() {
      }
    }
  },
  mounted() {
    this.getClientBoletosHistory();
  },
  methods: {
    async updateBoletosHistory(active) {
      if (!active) {
        if (this.selectedStatus.length === 0) {
          this.getTransactionsMessage = {
            message: 'No hay Boletos para mostrar. Prueba seleccionando otro filtro.',
            icon: 'sin-cuotas-pendientes.svg'
          };
        } else {
          await this.getClientBoletosHistory();
        }
      }
    },
    getDueDateBoleto(dueDate) {
      const [year, month] = dueDate.split('-').map(string => parseInt(string, 10));
      return new Date(year, (month - 1), new Date(year, month, 0).getDate()).toISOString().split('T')[0];
    },
    async getClientBoletosHistory() {
      this.isLoading = true;
      this.getBoletosMessage = '';
      this.getBoletosError = '';
      try {
        const { data } = await getClientBoletos(this.clientId, this.selectedStatus);

        this.boletos = data.sort((a, b) => a.createAt - b.createAt);
        this.boletos.forEach(bol => {
          // eslint-disable-next-line no-param-reassign
          bol.dueDateBoleto = this.getDueDateBoleto(bol.dueDate);
          // eslint-disable-next-line no-param-reassign
          bol.statusTranslate = this.statusDictionary[bol.status];
        });
      } catch (error) {
        if (error.response) {
          if (error.response.status === 404) {
            this.getBoletosMessage = {
              message: 'No hay Boletos para mostrar. Prueba seleccionando otro filtro.',
              icon: 'sin-cuotas-pendientes.svg'
            };
          } else {
            this.getBoletosMessage = {
              message: 'Ocurrió un error tratando de obtener el historial de Boletos',
              icon: 'data_maintenance.svg'
            };
          }
        } else {
          this.getBoletosError = {
            message: 'Ocurrió un error tratando de obtener el historial de pagos',
            icon: 'data_maintenance.svg'
          };
        }
      }
      this.isLoading = false;
    }
  }
};
</script>
<style scoped>
  .card-item {
    overflow: visible;
  }
  .transactions-view {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    align-content: center;
    gap: 2rem;
  }
  .header-container {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex start;
    align-items: center;
    width: 100%;
    gap: 2rem;
  }
  .transactions-container {
    display: flex;
    flex-flow: column wrap;
    gap: 1.5rem;
    width: 100%;
  }
  @media (max-width: 400px) {
  .header-container {
    justify-content: center;
    gap: 1rem;
  }
}
</style>
